export default __webpack_public_path__ + "static/media/talent_review_icon.b43e513f.svg";